import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ThumbsUp = function ThumbsUp() {
  return /*#__PURE__*/_jsxs("svg", {
    "aria-hidden": "true",
    role: "presentation",
    height: "26",
    width: "26",
    children: [/*#__PURE__*/_jsx("title", {
      children: "Thumbs Up Icon"
    }), /*#__PURE__*/_jsx("use", {
      href: "#thumbs-up"
    })]
  });
};

export default ThumbsUp;